import axios from 'axios';

const api = axios.create({
	// PI eCommerce API (pi_ecommerce_api)
	baseURL: process.env.REACT_APP_API_URL || 'http://localhost:2101/api/v1',
	headers: {
		'Content-type': 'application/json',
	},
});

// Request interceptor to add bearer token + the active store, since role is
// per-store now (user_store_access.role) and the backend resolves the
// caller's effective role fresh per-request from this header rather than a
// static JWT claim -- see pi_ecommerce_api's storeScope.ts#attachStoreScope.
api.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('authToken');
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		const activeStoreId = localStorage.getItem('activeStoreId');
		if (activeStoreId) {
			config.headers['X-Store-Id'] = activeStoreId;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor for error handling
api.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error.response ? error.response.status : null;

		if (status === 401) {
			// A 401 from signin itself is just bad credentials - let the login
			// form show the error instead of reloading the page
			const isSigninRequest = error.config?.url?.includes('/signin');
			const isOnLoginPage = window.location.pathname === '/login';

			if (!isSigninRequest && !isOnLoginPage) {
				// Expired/invalid session - clear auth and redirect to login
				localStorage.removeItem('authToken');
				localStorage.removeItem('userProfile');
				window.location.href = '/login';
			}
			return Promise.reject(error);
		} else if (status === 404) {
			// Handle not found errors
			console.error('Resource not found:', error?.response);
		} else {
			// Handle other errors
			console.error('An API error occurred:', error?.response);
		}

		return Promise.reject(error);
	}
);

export default api;
